import {
  type FC, useCallback,
} from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from '~/_shared/utils/hooks';
import {
  useMapSettingsDirectionsCollapseMarkersSelector,
  useMapSettingsDirectionsSelectedCollapsingSelector, useMapSettingsDirectionsShouldBeginAtUserLocationSelector,
} from '~/store/mapSettings/directions/mapSettingsDirections.selectors';
import { useIsUserOverDirectionsApiLimit } from '~/store/userData/userData.selectors';
import { useDirectionsCanDragRoutesSelector } from '../../store/frontendState/mapTools/directions/directions.selectors';
import { setMapDirectionSettings } from '../../store/mapSettings/directions/mapSettingsDirections.actionCreators';
import {
  DirectionsSettingsComponent, type onChangeParams,
} from './directionsSettings.component';

export type DirectionSettingsModalContainerProps = Readonly<{
  isOpen: boolean;
  onClose: () => void;
}>;

export const DirectionSettingsModalContainer: FC<DirectionSettingsModalContainerProps> = (props) => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const selectedCollapsing = useMapSettingsDirectionsSelectedCollapsingSelector();
  const canDragRoutes = useDirectionsCanDragRoutesSelector();
  const shouldBeginAtUserLocation = useMapSettingsDirectionsShouldBeginAtUserLocationSelector();
  const overDirectionsApiUsage = useIsUserOverDirectionsApiLimit();
  const areMarkersCollapsed = useMapSettingsDirectionsCollapseMarkersSelector();

  const onChange = useCallback((settings: onChangeParams) => {
    dispatch(setMapDirectionSettings(
      settings.collapsingLevel,
      settings.canDragRoutes,
      settings.shouldBeginAtUserLocation,
      settings.areMarkersCollapsed,
    ));
  }, [dispatch]);

  const draggingDisabledReason = overDirectionsApiUsage ? t('directionsTool.errors.overUsageLimit') : undefined;

  return (
    <DirectionsSettingsComponent
      {...props}
      draggingDisabledReason={draggingDisabledReason}
      onChange={onChange}
      selectedCollapsing={selectedCollapsing}
      canDragRoutes={canDragRoutes}
      shouldBeginAtUserLocation={shouldBeginAtUserLocation}
      areMarkersCollapsed={areMarkersCollapsed}
    />
  );
};
